import React, { useState } from 'react';

const PercentageDifferenceCalculator = () => {
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');

  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('يرجى ادخال القيمتين بشكل صحيح');
      setResult('');
      setExplanation('');
      return;
    }
    const diff = Math.abs(parseFloat(value1) - parseFloat(value2));
    const sum = parseFloat(value1) + parseFloat(value2);
    const percentageDiff = (diff / sum) * 100;
    setResult(percentageDiff.toFixed(3));
    setExplanation(
      `الفرق بين ${value1} و ${value2} = |${value1} - ${value2}| = ${diff}\n(${value1} + ${value2}) / 2 = ${sum} / 2 = ${sum / 2}\n= ${diff} / ${sum / 2} = ${(diff / (sum / 2)).toFixed(3)}\n= ${percentageDiff.toFixed(3)}%\n= ${percentageDiff.toFixed(3)}`
    );
    setError('');
  };

  return (
    <div dir="rtl">
      <style>{`
        .calc-wrapper {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
        }
        .calc-btn {
          font-size: 20px;
          white-space: nowrap;
        }
        @media (max-width: 767px) {
          .calc-btn {
            width: 100%;
            margin-top: 6px;
            text-align: center;
          }
        }
      `}</style>

      <u><h2 style={{ fontSize: '16px' }}>حاسبة الفرق المئوي</h2></u><br />

      <div className="calc-wrapper">
        <span>الفرق بين</span>
        <input
          type="number"
          placeholder="القيمة 1"
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '80px' }}
        />
        <span>و</span>
        <input
          type="number"
          placeholder="القيمة 2"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '80px' }}
        />
        <button
          className="btn btn-success"
          onClick={handleCalculate}
        >
          إحسب
        </button>
      </div>
      <br/>

      <div>
        {error !== '' ? (
          <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className="p-3 mb-2 bg-success text-white">
                  النتيجة: الفرق بين {value1} و {value2} هو {result}%
                </p>
                {explanation !== '' && (
                  <p className="p-3 mb-2 bg-info text-black">
                    خطوات الحل: <br />{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PercentageDifferenceCalculator;